/**
 * action types
 */
export const SET_INSTITUTION_ENROLMENT = 'SET_INSTITUTION_ENROLMENT';
